const svSE = {
  glossary: {
    change: 'Ändra',
    showPrevious: 'Visa föregående',
    showNext: 'Visa nästa',
    showPreviousImage: 'Visa föregående bild',
    showNextImage: 'Visa nästa bild',
    readMore: 'Läs mer',
    closeModal: 'Stäng modalen',
    homeUrl: 'https://www.wayke.se',
    goToHome: 'Gå till wayke.se',
    company: 'Wayke',
    modalTitle: 'Wayke Ecom',
    add: 'Lägg till',
    chosen: 'Vald',
    ourAdvantages: 'Fördelar med att köpa bilen online hos oss',
    showHelp: 'Stäng hjälp',
    closeHelp: 'Stäng hjälp',
    whatDoesThisMean: 'Vad betyder detta?',
    buyOnline: 'Köp online hos oss',
  },
  confirmClose: {
    heading: 'Bilen är inte reserverad ännu',
    message:
      'Du har inte klickat dig igenom alla steg som krävs för att ordern ska slutföras och bilen ska reserveras till dig. Är du säker på att du vill avsluta din order?',
    abortButton: 'Fortsätt min order',
    confirmButton: 'Avbryt min order',
  },
  accessoryItemInfo: {
    backButton: 'Tillbaka',
    logoAlt: 'Tillverkarens logotyp för',
  },
  accessories: {
    title: 'Tillbehör',
    noSelected: 'Inga valda',
    changeButtonTitle: 'Ändra tillbehör',
    heading: 'Vill du köpa till ett tillbehör till din nya bil?',
    description: 'Här visar vi några av de tillbehör som passar din nya bil.',
    proceedButton: 'Gå vidare',
    skipButton: 'Hoppa över detta steg',
  },
  centralStorage: {
    title: 'Centrallager',
    heading: 'Vilken anläggning vill du köpa ifrån?',
    description:
      'Detta fordon är en centrallagerbil och finns tillgängligt från flera anläggningar. Välj den anläggning du vill handla ifrån.',
    changeButtonTitle: 'Ändra',
    proceedButton: 'Gå vidare',
    errorMessage:
      'Ett fel uppstod och det gick inte att välja ovanstående anläggning. Försök igen.',
    dealerSelection: 'Val av anläggning',
    addressMissing: 'Adress saknas',
  },
  confirmation: {
    title: 'Slutför ordern',
    paymentTitle: 'Betalning',
    heading: 'Strax klart!',
    description:
      'För att reservera bilen åt dig behöver vi bara verifiera din identitet med BankID. Efter det kommer {{name}} att kontakta dig för att slutföra köpet.',
    description2:
      'Köpet blir bindande först när du signerat det definitiva affärsförslaget med {{name}}. Det är även då betalningen sker.',
    ageError:
      'Du måste vara över 18 år för att kunna fortsätta. Identifiering med BankId visar att du är under 18 år gammal.',
    requestError: 'Ett fel uppstod och det gick inte att skapa ordern, försök igen.',
    notAvailable: 'Den här bilen finns tyvärr inte längre tillgänglig.',
    socialIdNotMatchingError:
      'Personnummret i första steget matchar inte med det som är kopplat mot bankid',
    confirmConditionsTitle: 'Jag godkänner {{link}}.',
    insuranceText: 'samt har tagit del av information kring försäkringsförmedling',
    reserveButton: 'Reservera bilen',
    policyText: 'Dina personuppgifter behandlas och sparas i enlighet med vår {{link}}.',
    reservationDisclaimer:
      'Vi reserverar oss för eventuell ändring i tillgången av utbjudna bilar.',
    bankIdDescriptionQrCode:
      'För att verifiera din identitet, starta din BankID applikation på din andra enhet.',
    bankIdDescriptionSameDevice: 'För att verifiera din identitet, starta din BankID-applikation.',
    bankIdErrorMessage: 'Det gick inte att hämta status kring nuvanrade BankId signering.',
    bankIdQrCodeErrorMessage: 'Det gick inte att hämta ny QR-kod för BankId signering.',
    bankIdInitErrorMessage: 'Det gick tyvärr inte att initiera BankId. Vänligen försök igen.',
    bankIdCompletedMessage: 'Verifiering klar, ordern skapas nu...',
    paymentHeading: 'Välj betalsätt',
    paymentDescription:
      'Genomför en förskottsbetalning på 5% av bilens pris (10 995 kr) för att reservera bilen. Välj hur du vill genomföra betalningen.',
    paymentDescription2:
      'Resterande del av kontantinsatsen 32 985 kr med eventuellt avdrag av värde för inbytesbil betalas hos {{name}} vid kontraktskrivning.',
    paymentCardType: 'Korttyp',
    paymentCardTypeValue: 'Credit',
    paymentCardNo3DSecure: 'Kort utan 3d secure',
    paymentCardNo3DSecureValue: '4925000000000004',
    paymentCard3DSecure: 'Kort med 3d secure',
    paymentCard3DSecureValue: '4761739001010416',
    paymentExpiry: 'MM/ÅÅ:',
    paymentExpiryValue: '12/25',
    paymentCVC: 'CVC:',
    paymentCVCValue: '123',
    privacyPolicy: 'personuppgiftspolicy',
    purchaseTermsAndCancellationPolicy: 'köpvillkor och villkor för ångerrätt',
    noVerifyConfirmMessage:
      'Ex exercitation excepteur commodo est reprehenderit ad pariatur cillum quis esse aute.',
  },
  customer: {
    title: 'Dina uppgifter',
    changeButtonTitle: 'Ändra dina uppgifter',
    email: 'E-post',
    phone: 'Telefonnummer',
    socialId: 'Personnummer',
    name: 'Namn',
    givenName: 'Förnamn',
    surname: 'Efternamn',
    address: 'Adress',
    street: 'Gatuadress',
    street2: 'Lägenhet, våning, etc.',
    registeredAddress: 'Folkbokföringsadress',
    postalCode: 'Postnummer',
    city: 'Stad',
    contactInfoTitle: 'Kontaktuppgifter',
    contactInfoDescription: 'Ange din e-postadress och ditt telefonnummer.',
    emailPlaceholder: 'Ange din e-postadress',
    emailErrorMessage: 'En giltig e-postadress måste anges',
    phonePlaceholder: 'Ange ditt telefonnummer',
    phoneErrorMessage: 'Ange ditt telefonnummer',
    givenNamePlaceholder: 'Ange ditt förnamn',
    givenNameErrorMessage: 'Ange ditt förnamn',
    surnamePlaceholder: 'Ange ditt efternamn',
    surnameErrorMessage: 'Ange ditt efternamn',
    streetPlaceholder: 'Ange din gatuadress',
    streetErrorMessage: 'Ange din gatuadress',
    street2Placeholder: 'Lägenhet, våning, etc.',
    street2ErrorMessage: 'Lägenhet, våning, etc.',
    postalCodePlaceholder: 'Ange ditt postnummer',
    postalCodeErrorMessage: 'Ange ditt postnummer',
    cityPlaceholder: 'Ange din stad',
    cityErrorMessage: 'Ange din stad',
    proceedButton: 'Gå vidare',
    personalInfoTitle: 'Personuppgifter',
    personalInfoDescription: 'Ange ditt personnummer för att hämta ditt namn och din adress.',
    socialIdPlaceholder: 'ÅÅÅÅMMDD-XXXX',
    socialIdErrorMessage: 'Ange personnummer i formatet ÅÅÅÅMMDD-XXXX. Måste vara över 18 år.',
    fetchButton: 'Hämta uppgifter',
    fetchErrorMessage: 'Tyvärr fick vi ingen träff på personnumret du angav.',
    fetchInfoMessage: 'Vi kommer hämta följande uppgifter om dig:',
    policyText: 'Dina personuppgifter behandlas och sparas i enlighet med vår {{link}}.',
    changeContactsButton: 'Ändra',
  },
  delivery: {
    title: 'Leverans',
    deliveryMethod: 'Leveranssätt',
    homeDelivery: 'Hemleverans',
    pickup: 'Hämta hos handlaren',
    changeDeliveryMethod: 'Ändra leveranssätt',
    heading: 'Hur vill du ha din bil levererad?',
    description:
      'Välj ifall du vill ha bilen levererad hem till dig eller ifall du vill hämta den hos {{name}}.',
    free: 'Gratis',
    toYourAddress: 'Till din folkbokföringsadress',
    tooFarAway: 'Tyvärr kan vi inte erbjuda hemleverans till din adress.',
    proceedButton: 'Gå vidare',
  },
  creditAssessment: {
    loanApplication: 'Låneansökan',
    loanApplicationDescription:
      'För att besvara din förfrågan om billån behöver {{name}} några fler uppgifter om dig och ditt hushåll. Frågorna tar bara någon minut att besvara. Bekräfta och signera sedan med BankID – därefter får du ditt lånebesked direkt på skärmen och kan gå vidare med ditt bilköp. Blir du godkänd så gäller lånebeskedet genom hela köpet så länge inga tillägg görs – men din ansökan är inte bindande.',
    maritalStatus: 'Civilstatus',
    employment: 'Sysselsättning',
    children: 'Barn',
    income: 'Inkomst',
    housingType: 'Boendeform',
    housingTypeDescription: 'Ange typ av boende.',
    housingCost: 'Boendekostnad',
    debtsAndLiabilities: 'Skulder och Ansvarsförbindelser',
    debtsAndLiabilitiesDescription:
      'Ange eventuella skulder och ansvarsförbindelser inom respektive kategori.',
    totalLoanAmount: 'Totalt lånebelopp',
    noPaymentInfo:
      'Du betalar inget i detta steg, detta är bara en låneansökan. Köpet slutförs sedan vid möte med {{name}}.',
    caseError: 'Det gick inte att starta en låneansökan, försök igen. {{caseError}}',
    bankIdError: 'Ett fel uppstod med BankId, försök igen.',
    performLoanApplication: 'Genomför låneansökan',
    disclaimer:
      'Genom att klicka på ”Genomför låneansökan” godkänner jag att {{name}} gör en kreditupplysning på mig baserat på informationen ovan och jag bekräftar att jag läst {{link}}.',
    disclaimerSafe: 'Dina uppgifter lagras och sparas säkert.',
    whyAnswer: 'Varför måste jag svara på allt detta?',
    whyAnswerDescription:
      '{{name}} måste ta in uppgifterna av kunden för att uppfylla bestämmelser i Konsumentkreditlagen (2010:1846) och Lag (2017:630) om åtgärder mot penningtvätt och finansiering av terrorism. {{link}}',
    waitingFor: 'Väntar på {{name}}...',
    fetchingInfo: 'Hämtar uppgifter från {{name}}. Vänta kvar det kan ta några sekunder.',
    errorOccurred: 'Ett fel uppstod',
    bankIdStatusError: 'Det gick inte att hämta status kring nuvanrade BankId signering',
    descriptionQrCode:
      'För att hämta dina uppgifter, starta din BankID applikation på din andra enhet.',
    descriptionSameDevice: 'För att hämta dina uppgifter, starta din BankID-applikation.',
    incomePerMonth: 'Inkomst per månad före skatt',
    incomeError: 'Ange din inkomst per år före skatt',
    incomeDescription: 'Lön och/eller pension, inte bidrag eller studielån.',
    childrenUnder18: 'Antal barn under 18 år',
    childrenError: 'Välj antal barn',
    selectChildren: 'Välj antal barn',
    tenOrMore: '10 eller fler',
    myPartOfMonthlyFee: 'Min del av månadsavgiften',
    myPartOfMonthlyRent: 'Min del av månadshyran',
    excludingInterest: 'Exklusive ränta och amortering',
    housingCostError: 'Ange boendekostnader per månad',
    cardCredits: 'Kortkrediter',
    cardCreditsError: 'Ange kortkrediter eller lämna tomt',
    totalDebt: 'Total skuld',
    vehicleLoan: 'Billån',
    vehicleLoanError: 'Ange billån eller lämna tomt',
    collateral: 'Borgensåtagande',
    collateralError: 'Ange borgensåtagande eller lämna tomt',
    totalAmount: 'Totalt belopp.',
    leasingFees: 'Billeasing',
    leasingFeesError: 'Ang billeasingkostnader eller lämna tomt',
    privateLoan: 'Privatlån (ej bolån och CSN)',
    privateLoanError: 'Ange privatlån eller lämna tomt',
    fullTimeEmployed: 'Fast eller tillsvidareanställd',
    temporarilyEmployed: 'Visstidsanställd',
    selfEmployed: 'Egen företagare',
    retired: 'Pensionär',
    student: 'Student',
    other: 'Annan',
    married: 'Gift/partnerskap',
    commonLaw: 'Sambo',
    single: 'Ensamstående',
    singleFamily: 'Villa',
    condominium: 'Bostadsrätt',
    apartment: 'Hyresrätt',
    proceedButton: 'Gå vidare',
    abortButton: 'Avbryt',
    assessManually:
      'Kreditupplysningen måste göras manuellt. Vänligen kontakta {{name}} för att fortsätta.',
    dataProtectionPolicy: 'dataskyddspolicy',
    readMore: 'Läs mer om detta här',
  },
  financial: {
    title: 'Finansiell information',
    description: 'Ange din finansiella information för att fortsätta.',
    income: 'Inkomst',
    incomePlaceholder: 'Ange din inkomst',
    incomeErrorMessage: 'En giltig inkomst måste anges',
    expenses: 'Utgifter',
    expensesPlaceholder: 'Ange dina utgifter',
    expensesErrorMessage: 'Giltiga utgifter måste anges',
    assets: 'Tillgångar',
    assetsPlaceholder: 'Ange dina tillgångar',
    assetsErrorMessage: 'Giltiga tillgångar måste anges',
    liabilities: 'Skulder',
    liabilitiesPlaceholder: 'Ange dina skulder',
    liabilitiesErrorMessage: 'Giltiga skulder måste anges',
    proceedButton: 'Gå vidare',
    abortButton: 'Avbryt',
    heading: 'Ägandeform',
    howToFinance: 'Hur vill du finansiera din {{vehicleTitle}} {{vehicleDescription}}?',
    buyCar: 'Köp bilen',
    buyCarDescription:
      'Du köper bilen och äger den själv, antingen genom att betala hela bilen med egna medel eller genom ett billån. Du ansvarar själv för försäljningen av bilen och väljer såklart helt fritt när den ska äga rum.',
    leaseCar: 'Leasa bilen',
    leaseCarDescription:
      'När du privatleasar en bil äger du den inte själv utan betalar en månadsavgift under en avtalad tid och som täcker en viss körsträcka och andra avtalade tjänster.',
    cash: 'Kontant',
    cashDescription:
      'Betalning sker hos {{contactName}} vid kontraktskrivning. Inga kostnader tillkommer.',
    loanApplicationOnline: 'Låneansökan online med BankID',
    loanApplicationResponse: ' – svar direkt!',
    paymentAtContract: 'Betalning sker hos {{contactName}} vid kontraktskrivning.',
    calculatedOn: 'Beräknat på {{creditAmount}} kr, {{duration}} mån, {{interest}}% ränta.',
    from: 'Från',
    proceed: 'Gå vidare',
    privateLeasing: 'Privatleasing',
    privateLeasingDescription:
      'När du privatleasar en bil äger du den inte själv utan betalar en månadsavgift under en avtalad tid och som täcker en viss körsträcka och andra avtalade tjänster.',
    financialInformationToggle: 'Finansiell information',
    financialCashSelected: 'Kontant betalning vald',
    financialLeaseSelected: 'Privatleasing vald',
    financialLoanSelected: 'Billån valt',
    financialCashSet: 'Kontant betalning satt',
    financialLeaseSet: 'Privatleasing satt',
    financialLoanSet: 'Billån satt',
    financialEdit: 'Redigera finansiering',
  },
  loan: {
    title: 'Billån',
    description: 'Finansiera bilen med billån via {{name}}.',
    creditScoringInfo:
      'Gör din låneansökan här - och få besked direkt. Kom ihåg, köpet är inte bindande förrän du signerat det definitiva affärsförslaget som tas fram av {{name}}.',
    instruction:
      'Ange din tänkta kontantinsats och hur många månader du vill lägga upp ditt lån på.',
    downPaymentTitle: 'Kontantinsats',
    downPaymentInfoTitle: 'Hur mycket av dina egna pengar vill du lägga?',
    downPaymentInfoDescription:
      'Kontantinsatsen är en del av bilens pris som du betalar med egna pengar. Den behöver vara minst 20% av priset på bilen. Kontantinsatsen betalar du senare i samband med avtalsskrivning hos {{name}}. Ifall du har en inbytesbil kan du betala kontantinsatsen med den. Detta kommer du överens om tillsammans med {{name}} vid avtalsskrivning.',
    durationTitle: 'Avbetalning',
    residualTitle: 'Restvärde',
    errorOccurred: 'Ett fel uppstod, försök igen.',
    proceedButton: 'Gå vidare',
  },
  loanDetails: {
    disclaimerText:
      '*Beräknat på {{interest}} % ränta (effektivt {{effectiveInterest}} %). Den ränta du får sätts vid avtalskrivning.',
    showDetails: 'Visa detaljer',
    details: 'Detaljer',
    repaymentPeriod: 'Avbetalningsperoid',
    months: 'mån',
    interest: 'Ränta',
    effectiveInterest: 'Effektiv ränta',
    setupFee: 'Uppläggningskostnad',
    administrationFee: 'Administrativa kostnader',
    totalCreditCost: 'Total kreditkostnad',
    disclaimerText1:
      '*Det här är inte den slutgiltiga offerten. Räntan kan komma att ändras ifall det sker justeringar i initial amorteringsplan, tillägg i utrustning eller andra ändringar som påverkar det initiala prisförslaget.',
    disclaimerText2:
      'Om marknadsräntan förändras kan månadskostnaden komma att ändras i motsvarande mån. Månadskostnaden kan också komma att påverkas utifrån den kreditriskbedömning som görs efter en kreditupplysning.',
    moreInfo: 'Mer information om {{loanOrgName}}',
  },
  loanDetailsDetailed: {
    showDetails: 'Visa detaljer',
    details: 'Detaljer',
    repaymentPeriod: 'Avbetalningsperoid',
    months: 'mån',
    interest: 'Ränta',
    effectiveInterest: 'Effektiv ränta',
    setupFee: 'Uppläggningskostnad',
    administrationFee: 'Administrativa kostnader',
    totalCreditCost: 'Total kreditkostnad',
    disclaimerText1:
      '*Det här är inte den slutgiltiga offerten. Räntan kan komma att ändras ifall det sker justeringar i initial amorteringsplan, tillägg i utrustning eller andra ändringar som påverkar det initiala prisförslaget.',
    disclaimerText2:
      'Om marknadsräntan förändras kan månadskostnaden komma att ändras i motsvarande mån. Månadskostnaden kan också komma att påverkas utifrån den kreditriskbedömning som görs efter en kreditupplysning.',
    moreInfo: 'Mer information om {{loanOrgName}}',
  },
  loanDetailsMonthlyCost: {
    monthlyCost: 'Månadskostnad för lånet',
    perMonth: 'kr/mån*',
  },
  stageCompletedFinancial: {
    downPayment: 'Kontantinsats',
    loanAmount: 'Lånebelopp',
    repaymentPeriod: 'Avbetalningsperoid',
    months: 'mån',
    monthlyCost: 'Månadskostnad för lånet',
    disclaimerText:
      '*Beräknat på {{interest}} % ränta (effektivt {{effectiveInterest}} %). Den ränta du får sätts vid avtalskrivning.',
    orderAlmostReady: 'Ordern är snart klar, här ser du ditt lånebesked:',
    changeFinancing: 'Ändra finansiering',
    financing: 'Finansiering',
    cash: 'Kontant',
    lease: 'Privatleasing',
  },
  stageCompletedFinancialCreditAssessment: {
    approved: 'Grattis! Din låneansökan har beviljats av {loanName}.',
    approvedDescription:
      'Slutför ordern genom att klicka dig igenom nästkommande steg. Har du frågor under tiden? Kontakta {{contactName}} på tel {{contactPhone}}.',
    assessManually:
      'När ordern är slutförd kommer vi att gå igenom ditt ärende och återkoppla till dig med ett lånebesked.',
    assessManuallyDescription:
      'Din bil är fortfarande inte reserverad. Gå vidare till nästa steg för att slutföra ordern, men det är inte säkert att ditt lån kommer att beviljas. Har du frågor under tiden? Kontakta {{contactName}} på tel {{contactPhone}}.',
    declined: 'Vi kan tyvärr inte bevilja din ansökan om billån.',
    declinedDescription:
      'Det kan finnas olika skäl till att en ansökan nekas. Du kommer inom kort få ett brev med bekräftelse och mer information om just din ansökan.',
    declinedNextSteps:
      'Ditt redan påbörjade köp kan fortfarande genomföras och avslutas, för att gå vidare kan du välja ett annat betalsätt.',
    contactInfo: 'Har du frågor under tiden? Kontakta {{contactName}} på tel {{contactPhone}}.',
  },
  loanSummary: {
    title: 'Billån',
    description: 'Ordern är snart klar, här ser du ditt lånebesked:',
    successMessage: 'Grattis! Din låneansökan har beviljats av {{loanName}}.',
    notReserved:
      'Bilen är inte reserverad ännu. Slutför ordern genom att klicka dig igenom nästkommande steg. Har du frågor under tiden? Kontakta [handlaren] på tel [telefonnummer].',
    downPayment: 'Kontantinsats',
    loanAmount: 'Lånebelopp',
    repaymentPeriod: 'Avbetalningsperoid',
    monthlyCost: 'Månadskostnad för lånet',
    disclaimer:
      '*Beräknat på X,XX % ränta (effektivt X,XX %). Den ränta du får sätts vid avtalskrivning.',
  },
  summary: {
    financing: 'Finansiering',
    cash: 'Kontant',
    loan: 'Billån',
    leasing: 'Privatleasing',
    changeButton: 'Ändra',
    centralStorageTitle: 'Centrallager',
    dealerSelection: 'Val av handlare',
    customerTitle: 'Kunduppgifter',
    customerName: 'För- och efternamn',
    customerSSN: 'Personnummer',
    customerAddress: 'Adress',
    customerEmail: 'E-post',
    customerPhone: 'Telefonnummer',
    deliveryTitle: 'Leverans',
    deliveryMethod: 'Leveranssätt',
    homeDelivery: 'Hemleverans',
    pickup: 'Hämta hos handlaren',
    thankYou: 'Tack för din order!',
    whatHappensNext: 'Det här händer nu:',
    orderConfirmation: 'En orderbekräftelse kommer att skickas till din e-postadress {{email}}.*',
    contactFromDealer:
      '{{contactName}} tar kontakt med dig för att gå igenom avtal, betalning och leverans.',
    driveSafely: 'Klart! Kör försiktigt ute på vägarna.',
    orderConfirmationDisclaimer:
      '*Orderbekräftelsen skickas normalt inom 10 minuter, men kan i undantagsfall dröja upp till 48 timmar.',
    orderNumber: 'Ordernummer {{createdOrderId}}',
    orderTitle: 'Din order',
    paymentMethod: 'Betalsätt',
    perMonth: 'kr/mån',
    lease: 'Privatleasing',
    from: 'Från',
    accessories: 'Tillbehör',
    insurance: 'Försäkring',
    free: 'Gratis',
    tradeInTitle: 'Inbytesbil',
    mileage: 'Miltal',
    description: 'Beskrivning',
    condition: 'Bilens skick',
    estimatedValue: 'Ungefärligt värde',
    no: 'Nej',
  },
  insurance: {
    heading: 'Vill du teckna en försäkring på din nya bil?',
    description: 'Nedan visas förslag på försäkringar som passar dig och din nya bil.',
    proceedButton: 'Gå vidare',
    backButton: 'Tillbaka',
    logoAlt: 'Tillverkarens logotyp för {{title}}',
    ifDescription:
      'Ange din uppskattade körsträcka för att se din försäkringskostnad. Därefter presenterar vi förslag på försäkringar som passar dig och din nya bil. I både hel- och halvförsäkring ingår trafikförsäkring som är obligatoriskt att ha. Ifall du har valt att finansiera bilen med ett billån är priset du ser rabatterat.',
    showInsurances: 'Visa försäkringar',
    ifAlert:
      'Vi är anknutna försäkringsförmedlare till {{insuranceDisclaimerTitle}}, If Skadeförsäkring. Försäkringsgivare är If Skadeförsäkring (publ). Vad detta innebär kan du läsa mer om på försäkringsförmedlarens hemsida.',
    ifDisclaimer:
      'Genom att du klickar på Visa försäkringar så godkänner du att vi skickar dina uppgifter vidare till {{insuranceDisclaimerTitle}} för att de ska kunna ge dig ett pris på försäkring. Hur de hanterar dina personuppgifter kan du läsa om på deras hemsida.',
    skipButton: 'Hoppa över detta steg',
    perMonth: 'kr/mån',
    addons: 'Tillval',
    includes: 'Försäkringen innehåller',
    update: 'Uppdatera',
    select: 'Välj',
    estimatedMileage: 'Uppskattad körsträcka',
    edit: 'Ändra',
    fetchError: 'Det gick inte att hämta försäkringar.',
    retry: 'Försök igen',
    title: 'Försäkring',
    none: 'Ingen',
    changeButtonTitle: 'Ändra försäkring',
  },
  tradeIn: {
    title: 'Inbytesbil',
    mileage: 'Miltal',
    description: 'Beskrivning',
    condition: 'Bilens skick',
    estimatedValue: 'Ungefärligt värde',
    infoText: 'Vi skickar med uppgifter om din inbytesbil till bilhandlaren.',
    infoDisclaimer:
      'Observera att värderingen som utförs ger ett uppskattat inbytesvärde. Det slutgiltliga värdet avgörs när handlare kan bekräfta bilens skick.',
    no: 'Nej',
    changeButtonTitle: 'Ändra',
    heading: 'Har du en inbytesbil?',
    tradeInDescription:
      'Har du en bil du vill byta in när du köper din nya bil? Här får du ett uppskattat inköpspris av oss direkt online.',
    yesButton: 'Jag har inbytesbil',
    skipButton: 'Hoppa över detta steg',
    veryGoodCondition: 'Mycket bra skick',
    goodCondition: 'Bra skick',
    okCondition: 'Helt okej skick',
    noScratches: 'Inga repor eller skador',
    serviced: 'Servad vid varje tillfälle med stämplar i serviceboken',
    goodTires: 'Däck med väldigt bra mönsterdjup (5-8 mm)',
    someScratches: 'Några mindre repor och/eller skador',
    okTires: 'Däck som inte behöver bytas (mönsterdjup om 3-5 mm)',
    manyScratches: 'Finns en del repor och skador',
    notServiced: 'Inte servad vid varje tillfälle',
    badTires: 'Däck som behöver bytas (mönsterdjup under 3 mm)',
    detailsHeading: 'Uppgifter om din inbytesbil',
    detailsDescription:
      'Ange registreringsnumret och aktuellt miltal för din inbytesbil så får du ett uppskattat inköpspris av oss.',
    registrationNumber: 'Registreringsnummer',
    registrationNumberError:
      'Ett giltig registreringsnummer i formatet ABC123 eller ABC12A måste anges',
    registrationNumberPlaceholder: 'Ange registreringsnummer',
    mileageError: 'Ett miltal mellan 0 till 80 000 mil måste anges',
    mileagePlaceholder: 'Ange bilens miltal',
    descriptionOptional: 'Beskrivning (valfritt)',
    descriptionError: 'Beskrivningen är inte giltig',
    descriptionPlaceholder: 'Beskriv bilen',
    fetchValue: 'Hämta uppskattat värde',
    proceedButton: 'Använd och gå vidare',
    fetchError:
      'Tyvärr fick vi ingen träff på registreringsnummret du angav. Vänligen kontrollera att registreringsnummret stämmer.',
  },
  vehicleInfo: 'Fordonsinformation',
  orderCallback: {
    thankYou: 'Tack för ditt köp',
    orderId: 'Order id',
    waykeId: 'Wayke id',
  },
  howTo: {
    heading: 'Så här köper du bilen online',
    description:
      'Hos oss kan du tryggt köpa din nästa bil online. Reservera bilen genom att klicka dig igenom vårt köpflöde med följande steg:',
    timelineAriaLabel: 'Tillvägagångssätt',
    customerHeading: 'Dina kunduppgifter',
    centralStorageHeading: 'Välj anläggning',
    centralStorageDescription: 'Välj vilken anläggning du vill köpa bilen ifrån.',
    deliveryHeading: 'Välj leveranssätt',
    tradeInHeading: 'Har du inbytesbil?',
    tradeInDescription: 'Få den värderad direkt online.',
    financialHeading: 'Ägandeform',
    insuranceHeading: 'Vill du teckna en försäkring?',
    insuranceDescription: 'Se förslag på försäkringar som passar din nya bil.',
    accessoriesHeading: 'Tillbehör',
    accessoriesDescription: 'Beställ extra utrustning till din bil.',
    financialDescriptionAll:
      'Denna bil kan du köpa kontant, privatleasa eller finansiera med ett billån.',
    financialDescriptionCashLease: 'Denna bil kan du köpa kontant eller privatleasa.',
    financialDescriptionCashLoan: 'Denna bil kan du köpa kontant eller finansiera med ett billån',
    financialDescriptionLoanLease: 'Denna bil kan du privatleasa eller finansiera med ett billån',
    financialDescriptionCash: 'Denna bil kan du köpa kontant.',
    financialDescriptionLoan: 'Denna bil kan du finansiera med ett billån',
    financialDescriptionLease: 'Denna bil kan du privatleasa.',
    deliveryDescriptionBoth: 'Hemleverans eller hämta hos handlaren.',
    deliveryDescriptionPickup: 'Hämta hos handlaren.',
    deliveryDescriptionHome: 'Hemleverans.',
    paymentHeading: 'Genomför förskottsbetalning!',
    paymentDescription:
      'Genomför förskottskottsbetalning på 5% av bilens värde. (Genomför betalning av deposition motsvarande 5% av bilens värde.)',
    finalHeading: 'Klart!',
    finalDescription:
      'Efter att ordern är genomförd tar {{contactName}} kontakt med dig så kommer ni tillsammans fram till detaljer kring betalning och skriver avtal.',
  },
  preview: {
    heading: 'Vad roligt att du vill köpa denna bil!',
    proceedButton: 'Gå vidare',
    checklistTitle: 'Köp online hos Wayke',
    checklistAriaLabel: 'Fördelar med att köpa bilen online hos Wayke',
    checklistItem1: 'Trygg hantering av personuppgifter',
    checklistItem2: 'Reservera bilen nu - betalning och avtalsskrivning sker senare med handlaren',
    checklistItem3: 'Inte bindande förrän avtal skrivits ihop med handlaren',
    checklistItem4: 'Bara kontrollerade bilar',
    error: 'Ett fel uppstod och det gick inte att initiera modulen. Försök igen.',
  },
};

export default svSE;
